import {connect} from 'react-redux';

import {getIsUserGlobalAdmin} from '../../../../libs/shared/core/src/store/data/access/commonAccessSelectors';
import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {CardAttributeUpdateAction} from '../../../helpers/models/cardAttributeUpdateHelpers';
import {CardModel} from '../../../models/api/cardModel';
import {getCustomFieldsForCards} from '../../../store/data/customFields/customFieldsSelectors';
import {navigateToLinkAction} from '../../../store/stateless/navigationActions';
import {AddInformationPopover} from './addInformationPopover';

/*
 * Props.
 */

interface AddInformationPopoverContainerProps {
  card: CardModel | undefined;
  onAddInformation: (action: CardAttributeUpdateAction) => void;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<AddInformationPopoverContainerProps>()(() => ({
  customFieldsMap: getCustomFieldsForCards,
  isUserGlobalAdmin: getIsUserGlobalAdmin,
}));

const mapDispatchToProps = {
  onNavigateToCustomFieldsSettings: () =>
    navigateToLinkAction('/settings/global/custom-fields/cards/overview'),
};

export const AddInformationPopoverContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddInformationPopover);
